import { render, staticRenderFns } from "./FloatingWarning.vue?vue&type=template&id=1fe94830&scoped=true&"
import script from "./FloatingWarning.vue?vue&type=script&lang=js&"
export * from "./FloatingWarning.vue?vue&type=script&lang=js&"
import style0 from "./FloatingWarning.vue?vue&type=style&index=0&id=1fe94830&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe94830",
  null
  
)

export default component.exports